import { Component, Prop, Vue } from 'vue-property-decorator';
import required from '~/validators/required';

@Component
export default class InputFieldMixin extends Vue {
  @Prop({ default: '' }) label!: string;

  @Prop({ default: '' }) dataTest!: string;

  @Prop(Boolean) required!: boolean;

  @Prop({ default: '' }) customErrorLabel!: string;

  @Prop(Boolean) inPlace!: boolean;

  // To be overwritten if necessary
  defaultLabelAttr = '';

  // To be overwritten if necessary
  defaultDataTestAttr = '';

  get labelAttr(): string {
    return this.label || this.defaultLabelAttr || '';
  }

  get dataTestAttr(): string {
    if (this.dataTest) return this.dataTest;

    if (!this.labelAttr) return this.defaultDataTestAttr;

    const type = this.labelAttr.split(' ')[0].toLowerCase();
    return `${type}Input`;
  }

  // Should be used to pass the attributes to the child component
  // via `v-bind`. A replacement for `v-bind="$attrs"`.
  get attrs() {
    return { ...this.$attrs, ...this.$props };
  }

  isRequired(value?: string | number): string | boolean {
    if (required(value) || !this.required) return true;

    let errorLabel = '';
    if (this.customErrorLabel) {
      errorLabel = this.customErrorLabel;
    } else {
      const label = this.labelAttr.toLowerCase();
      errorLabel = label.charAt(0).toUpperCase() + label.slice(1);
    }
    return `${errorLabel} is required`;
  }
}
